/**
 * SHFTD Theme - Streamlined JavaScript
 */

// Set up namespace
window.SHFTD = window.SHFTD || {};

// Helper functions
SHFTD.Helpers = {
  /**
   * Format a number with leading zeros.
   * Always returns a string so strict-equality comparisons against
   * element.textContent (which is always a string) don't produce false
   * positives for two-digit values.
   */
  padZero: function(num) {
    return num < 10 ? '0' + num : String(num);
  },

  /**
   * Restart a one-shot CSS animation driven by a class toggle.
   *
   * Re-adding a class that's already present does NOT restart a CSS
   * animation, so we remove it, force a synchronous style recalc via
   * offsetWidth, then re-add it. This is deterministic and avoids the
   * setTimeout/setInterval race that caused countdown digits to
   * occasionally stop pulsing under main-thread jitter or tab throttling.
   */
  restartAnimation: function(element, className) {
    element.classList.remove(className);
    void element.offsetWidth;
    element.classList.add(className);
  }
};

// Initialize sections
SHFTD.Sections = {
  /**
   * Register event listeners for sections that require JavaScript
   */
  init: function() {
    // Countdown timers
    this.initCountdowns();
  },
  
  initCountdowns: function() {
    const countdowns = document.querySelectorAll('.hero-video__countdown, .giveaway-countdown, .build-details-hero__countdown');
    
    if (countdowns.length) {
      countdowns.forEach(function(countdown) {
        const endDate = countdown.getAttribute('data-end-date');
        
        // Set up the days, hours, minutes, seconds elements
        const daysElement = countdown.querySelector('[data-days]');
        const hoursElement = countdown.querySelector('[data-hours]');
        const minutesElement = countdown.querySelector('[data-minutes]');
        const secondsElement = countdown.querySelector('[data-seconds]');
        
        if (endDate) {
          // Prefer an explicit epoch (data-end-epoch, in seconds) when present so
          // the server-rendered initial digits and this script use the exact same
          // end time — no timezone drift, no "snap" correction after load.
          const endEpoch = parseInt(countdown.getAttribute('data-end-epoch'), 10);
          // Convert to timestamp or use a future date if invalid/empty
          let endDateTime;
          try {
            endDateTime = !isNaN(endEpoch) ? endEpoch * 1000 : new Date(endDate).getTime();
            // If date is invalid or in the past, use default (30 days from now)
            if (isNaN(endDateTime) || endDateTime <= Date.now()) {
              const defaultDate = new Date();
              defaultDate.setDate(defaultDate.getDate() + 30);
              endDateTime = defaultDate.getTime();
              console.log('Using default countdown date (30 days from now)');
            }
          } catch(e) {
            // Use default date of 30 days from now as fallback
            const defaultDate = new Date();
            defaultDate.setDate(defaultDate.getDate() + 30);
            endDateTime = defaultDate.getTime();
            console.log('Using default countdown date (30 days from now)');
          }
          
          // Update all digits and retrigger the pulse animation in a
          // single batch: write text, clear the animation class on every
          // digit, force one synchronous reflow, then re-add the class.
          // All four digits pulse together on a steady 1 s rhythm —
          // matching the adjacent "ENDING IN:" glow — with only one
          // forced layout per tick.
          function updateDigits(pairs) {
            const present = pairs.filter(function(p) { return p[0]; });
            present.forEach(function(p) {
              const el = p[0];
              const next = SHFTD.Helpers.padZero(p[1]);
              if (el.textContent !== next) el.textContent = next;
              el.classList.remove('number-changed');
            });
            if (present.length) void present[0][0].offsetWidth;
            present.forEach(function(p) {
              p[0].classList.add('number-changed');
            });
          }

          // Update the countdown every 1 second
          function renderCountdown() {
            // Get current date and time
            const now = new Date().getTime();
            
            // Find the time difference
            const distance = endDateTime - now;
            
            // Time calculations for days, hours, minutes and seconds
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);
            
            updateDigits([
              [daysElement, days],
              [hoursElement, hours],
              [minutesElement, minutes],
              [secondsElement, seconds]
            ]);
            
            // If the countdown is finished, show expired message
            if (distance < 0) {
              clearInterval(countdownInterval);
              
              // If there's an ended message element, show it
              const endedElement = countdown.querySelector('.giveaway-countdown__ended');
              if (endedElement) {
                endedElement.style.display = 'block';
                countdown.querySelector('.giveaway-countdown__items').style.display = 'none';
              } else {
                // Otherwise, just show zeros
                if (daysElement) daysElement.textContent = '00';
                if (hoursElement) hoursElement.textContent = '00';
                if (minutesElement) minutesElement.textContent = '00';
                if (secondsElement) secondsElement.textContent = '00';
              }
            }
          }

          // Render immediately so the digits show real values right away
          // (no 1-second "00" gap), then keep ticking once per second.
          const countdownInterval = setInterval(renderCountdown, 1000);
          renderCountdown();
        }
      });
    }
  }
};

// Initialize on DOM content loaded
document.addEventListener('DOMContentLoaded', function() {
  SHFTD.Sections.init();
}); 